import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ContactDetails {
  contact: any;
  availableCards: any[];
  enrichedCards: any[];
}

export interface ContactDetailsState {
  data: ContactDetails | null;
  loading: boolean;
  error: string | null;
}

const initialState: ContactDetailsState = {
  data: null,
  loading: false,
  error: null
};

export const contactDetailsSlice = createSlice({
  name: 'contactDetails',
  initialState,
  reducers: {
    contactDetailsRequest: (
      state,
      action: PayloadAction<{
        accountId: string;
        customerId: string;
        isRefresh: boolean;
        primaryAccountDetails: any;
      }>
    ) => {
      state.loading = true;
      state.error = null;
    },
    contactDetailsFetched: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    contactDetailsFetchFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  contactDetailsRequest,
  contactDetailsFetched,
  contactDetailsFetchFailed
} = contactDetailsSlice.actions;

export default contactDetailsSlice.reducer;